import { Map } from 'immutable'
import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { BlockData, ImageSize } from '../../cms/blocks/types.gen'
import { CustomBlock } from '../../drupal/types_and_parser/custom_blocks.mod'
import { Block } from '../../drupal/types_and_parser/standard_blocks.gen'
import { ParsedNode } from '../../drupal/types_and_parser/types'
import { CustomBlockData } from '../blocks/custom_blocks/types.mod'
import { Breadcrumb } from '../templates/breadcrumbs.mod'
import { getPage } from './api'

export type DrupalPageState = CMSState & {
  page: AsyncState<Page>
}

export type CMSState = {
  images: Map<number, AsyncState<Map<ImageSize, string>>>
  blocks: Map<number, BlockData | CustomBlockData>
}

export type Page = {
  node: CustomParsedNode
  blocks: Array<CustomBlock | Block>
  breadcrumbs: AsyncState<Array<Breadcrumb>>
}

export type CustomParsedNode = ParsedNode & { is_preview: boolean }

export const initialDrupalPageState = (slug: string): DrupalPageState => ({
  images: Map(),
  blocks: Map(),
  page: loadingAsyncState(() => getPage(slug))
})
